"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _PropertyInputText = _interopRequireDefault(require("customer-data-properties/input/PropertyInputText"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var PropertyInputName =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputName, _React$Component);

  function PropertyInputName() {
    (0, _classCallCheck2.default)(this, PropertyInputName);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputName).apply(this, arguments));
  }

  (0, _createClass2.default)(PropertyInputName, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        this.focus();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.inputText.focus();
    }
  }, {
    key: "getErrorKey",
    value: function getErrorKey() {
      var value = this.props.value;

      if (value && value.includes('"')) {
        return 'customerDataProperties.PropertyInputText.error.nameContainsDoubleQuote';
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var errorKey = this.getErrorKey();
      return _react.default.createElement(_UIFormControl.default, {
        error: !!errorKey,
        validationMessage: errorKey && _react.default.createElement(_FormattedHTMLMessage.default, {
          message: errorKey
        })
      }, _react.default.createElement(_PropertyInputText.default, (0, _extends2.default)({}, this.props, {
        ref: function ref(inputText) {
          _this.inputText = inputText;
        }
      })));
    }
  }]);
  return PropertyInputName;
}(_react.default.Component);

PropertyInputName.propTypes = {
  autoFocus: _react.PropTypes.bool,
  value: _react.PropTypes.oneOfType([_react.PropTypes.string.isRequired, _react.PropTypes.number.isRequired])
};
var _default = PropertyInputName;
exports.default = _default;
module.exports = exports.default;